import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useTranslations } from 'next-intl';

dayjs.extend(duration);

interface IProps {
  status?: string;
  time?: number;
  forBanner?: boolean;
}

const TimerBox: React.FC<IProps> = ({ status, time, forBanner = false }) => {
  const t = useTranslations();
  const [timeLeft, setTimeLeft] = useState({ hours: '00', minutes: '00', seconds: '00' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!time) return;

    const interval = setInterval(() => {
      const now = dayjs();
      const target = dayjs.unix(time); // time is unix timestamp
      const diff = target.diff(now); // can be negative
      const dur = dayjs.duration(diff > 0 ? diff : 0);

      setTimeLeft({
        hours: String(dur.hours()).padStart(2, '0'),
        minutes: String(dur.minutes()).padStart(2, '0'),
        seconds: String(dur.seconds()).padStart(2, '0')
      });
      setLoading(false);
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(interval);
  }, [time]);

  if (!time) return null;

  return (
    <>
      {loading ? (
        <div
          className={classNames('h-9 w-full animate-pulse rounded-lg bg-gray-100', {
            'max-w-36 sm:max-w-sm':
              forBanner
          })}
        />
      ) : (
        <div
          className={classNames('flex items-center justify-between gap-4 rounded-lg px-2 py-1 backdrop-blur-lg', {
            'mt-3 w-full bg-red-100': status === 'active',
            'bg-blue-100': status === 'inactive',
            'max-w-36 flex-col items-start bg-white/50 backdrop-blur-lg sm:max-w-sm sm:flex-row sm:items-center':
              forBanner
          })}
        >
          <p className="text-xs font-medium text-gray-800 sm:text-sm">
            {status === 'active' ? t('yakunlanishiga') : t('boshlanishiga')}
          </p>
          <div className="flex items-center space-x-1">
            <div className="rounded-md bg-white px-2 py-0.5 text-sm font-bold sm:text-base">{timeLeft.hours}</div>
            <span>:</span>
            <div className="rounded-md bg-white px-2 py-0.5 text-sm font-bold sm:text-base">{timeLeft.minutes}</div>
            <span>:</span>
            <div
              className={classNames('rounded-md px-2 py-0.5 text-sm font-bold sm:text-base', {
                'bg-red-500 text-white': status === 'active',
                'bg-blue-500 text-white': status === 'inactive',
                'bg-yellow-400 text-black': forBanner
              })}
            >
              {timeLeft.seconds}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TimerBox;
